import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import Quill from 'quill';


export default {
  data() {
    return ({
      user_details: {
        "user_role": '',
        "user_id": '',
      },
      group_report_name: '',
      group_feed_description: '',
      group_file_name: '',
      group_file_error: '',
      group_image_preview: null,
      group_audio_file_name: '',
      group_audio_error: '',
      group_audio_file: null,
      group_can_comment: true,
      isGroupRecording: false,
      upload_media: null,
      audio_file: null,
      errors: {},
      group_id: null,
      upload_files: [],
      quillContentLength: 0,
      isDragging: false,
    });
  },
  props: {
    activeProfile: { type: Object, default: null },
    companyName: {
      type: String,
      default: null,
      required: false,
    },
  },


  mounted() {
    this.user_details = get_user_details();
    const modalEl = document.getElementById('group_feed_modal');
    modalEl.addEventListener('shown.bs.modal', () => {
      this.initQuillEditor();
    });
  },
  computed: {
    is_post_empty() {
      // 1. Check for text (using the length we set in the Quill text-change event)
      const has_text = this.quillContentLength > 0;

      // 2. Check for uploaded files (images, docs, etc.)
      const has_media = this.upload_files.length > 0;

      // 3. Check for audio
      const has_audio = !!this.group_audio_file;

      // Return true (disable) only if ALL are empty
      return !(has_text || has_media || has_audio);
    },

    profileImage() {
      const type = this.activeProfile
      if (type?.profile_type === 'personal') {
        return this.getPersonalProfileImage()
      }
      if (type?.profile_type === 'business') {
        return this.getBusinessProfileImage()
      }

      return null
    },
    profile_image() {
      return this.getPersonalProfileImage()
    }
  },


  methods: {
    getPersonalProfileImage() {
      const files =
        this.activeProfile?.user?.profile?.profile_files || []

      const profilePic = files.find(
        f => f.profile_file_type === 'profile_picture'
      )

      return profilePic?.file?.url ?? null
    },
    handle_drop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        // Create a mock event to reuse your existing handleGroupFileUpload logic
        const mockEvent = { target: { files: files } };
        this.handleGroupFileUpload(mockEvent);
      }
    },

    getBusinessProfileImage() {
      const businessFiles =
        this.activeProfile?.company?.base_profile?.profile_files || []

      if (businessFiles.length) {
        return businessFiles[0]?.file?.file_url ?? null
      }

      return require('@/assets/images/user.png')
    },
    handleGroupFileUpload(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;

      this.group_file_error = null;
      const MAX_FILES = 10;

      // 1. Check if total files exceed limit
      if (files.length + this.upload_files.length > MAX_FILES) {
        this.group_file_error = `Maximum ${MAX_FILES} files allowed.`;
        return;
      }

      // 2. Loop through each selected file
      files.forEach(file => {
        // Skip if user tries to upload audio in the image/doc picker
        if (file.type.startsWith("audio/")) {
          this.group_file_error = "Please use the audio icon for music files.";
          return;
        }

        const reader = new FileReader();
        const isImage = file.type.startsWith("image/");

        reader.onload = (e) => {
          // Create a preview object for each file
          const fileData = {
            file: file, // the actual blob for the backend
            name: file.name,
            type: file.type,
            preview: isImage ? e.target.result : null, // base64 for images
            id: Date.now() + Math.random() // unique key for the UI
          };

          // Push to your reactive array
          this.upload_files.push(fileData);
        };

        if (isImage) {
          reader.readAsDataURL(file);
        } else {
          // For non-images (PDFs, etc.), just push immediately
          reader.onload({ target: { result: null } });
        }
      });

      // Clear the input so the same file can be picked again if deleted
      event.target.value = "";
    },

    // Add a method to remove specific files
    removeFile(index) {
      this.upload_files.splice(index, 1);
    },
    handleGroupAudioUpload(event) {

      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith("audio/")) {
          this.group_file_error = "Only audio files are allowed.";
          this.group_audio_file = null;
          this.group_audio_file_name = "";
          event.target.value = "";
        } else {
          this.group_audio_file = file;
          this.group_audio_file_name = file.name;
          this.group_file_error = "";
        }
      } else {

        this.group_audio_file = null;
        this.group_audio_file_name = "";
        this.group_file_error = "";
      }
    },
    startGroupRecording() {
      // Implement audio recording logic if needed
      this.isGroupRecording = true;
    },
    stopGroupRecording() {
      // Implement stop recording logic if needed
      this.isGroupRecording = false;
    },

    getQuillContent(quill) {
      let contentHtml = quill.root.innerHTML;

      return contentHtml.replace(
        /<span class="mention" data-value="([^"]*)"[^>]*>@[^<]*<\/span>/g,
        '@$1'
      );
    },
    create_group_feed() {
      this.errors = {};
      this.group_id = this.$route.params.group_id || null;
      const formData = new FormData();
      const description = this.quill ? this.getQuillContent(this.quill) : '';
      formData.append('description', description);
      formData.append('group_id', this.group_id);
      formData.append('can_comment', this.group_can_comment);
      if (this.upload_files && this.upload_files.length > 0) {
        this.upload_files.forEach((fileObj) => {
          formData.append('files', fileObj.file);
        });
      }
      if (this.group_audio_file) {
        formData.append('file', this.group_audio_file);
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_group_feed/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${get_token()}`,
        },
        beforeSend: function () {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
        },
        success: (response) => {
          Swal.close();
          const status = response.status;
          if (status === "success") {
            this.$emit('new_group_feed', response.feed_data);
            Swal.fire({
              icon: 'success',
              title: 'Feed Created',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#group_feed_modal').modal('hide');
              this.resetGroupFeedForm();
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data && response_data.status === "error") {
            this.errors.group_report_name = response_data.message;
          }
        }
      });
    },
    resetGroupFeedForm() {
      if (this.quill) {
        this.quill.setContents([]); // This clears all text and formatting
        this.quill.root.innerHTML = ""; // Double safety to ensure it's empty
      }

      // 2. Reset Text Length (for button disabling logic)
      this.quillContentLength = 0;

      // 3. Clear Multiple Files Array
      this.upload_files = [];
      this.group_report_name = '';
      this.group_feed_description = '';
      this.group_file_name = '';
      this.group_file_error = '';
      this.group_image_preview = null;
      this.group_audio_file_name = '';
      this.group_audio_error = '';
      this.group_audio_file = null;
      this.upload_media = null;
      this.group_can_comment = true;
      this.isGroupRecording = false;
      this.errors = {};
      this.$nextTick(() => {
        const fileInput = document.getElementById("groupFileInput");
        if (fileInput) fileInput.value = "";
        const audioInput = document.getElementById("groupAudioInput");
        if (audioInput) audioInput.value = "";
      });
    },
    initQuillEditor() {
      if (this.quill) return; // Prevent double initialization

      this.quill = new Quill('#quillEditor', {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean']
          ],
          mention: {
            allowedChars: /^[A-Za-z0-9_]+$/,
            mentionDenotationChars: ['@'],
            source: (searchTerm, renderList) => {
              const matches = this.members
                .filter(member => {
                  const fullName = `${member.full_name}`.toLowerCase();
                  return fullName.includes(searchTerm.toLowerCase());
                })
                .map(member => ({
                  id: member.id,
                  value: `${member.full_name}`
                }));
              renderList(matches);
            },
            renderItem(item) {
              return `${item.value}`;
            }
          }
        },
        placeholder: 'Type your text here...',
      });

      this.quill.on('text-change', () => {
        const text = this.quill.getText().trim();
        this.quillContentLength = text.length;
        // Sync HTML for submission
        const description = this.quill ? this.getQuillContent(this.quill) : '';
        this.group_feed_description = description;
      });
    },

  },
};



